import React, { PropsWithChildren } from "react";
import { Container, Stack, SxProps } from "@mui/material";

import { ScrollArrow } from "src/features";

type PageContainerProps = {
  mainComponent: React.ReactNode;
  containerSX?: SxProps;
  hidden?: boolean;
};

export const PageContainer: React.FC<PropsWithChildren<PageContainerProps>> = (
  props,
) => {
  const { mainComponent, children, containerSX, hidden } = props;

  return (
    <Container maxWidth={false} sx={containerSX}>
      <Stack
        width={1}
        height={1}
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
        spacing={4}
        useFlexGap
      >
        <Stack
          width={1}
          height="calc(100vh - 92px)"
          position="relative"
          direction="column"
          justifyContent="space-between"
          alignItems="center"
          useFlexGap
          marginTop={4}
          sx={{
            overflow: hidden ? "hidden" : "visible",
          }}
        >
          {mainComponent}

          <ScrollArrow />
        </Stack>
        {children}
      </Stack>
    </Container>
  );
};
